import { useState } from 'react';
// Components/ui
import { Box, TextField, Typography } from '@mui/material';
import { InputContainer } from '../../layout';
import LocationSelectorModal from './SendLocation/LocationSelectorModal';
// Types
import { UseFieldType } from '../../hooks/useField';
import { useTranslationContext } from '../../context/TranslationContext';
import PlaceIcon from '@mui/icons-material/Place';

type LocationTextFieldProps = {
  locationField: UseFieldType;
  disabled: boolean;
};

const LocationTextField = ({ locationField, disabled }: LocationTextFieldProps) => {
  const t = useTranslationContext();
  const [showModal, setShowModal] = useState(false);
  // Extraer type y value
  const { value, type, ...restAttributes } = locationField.attributes;
  const safeValue = value || '';

  const handleOpenModal = () => {
    if (!disabled) {
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleLocationSelect = (address: string) => {
    // Actualizar el campo con la dirección seleccionada
    locationField.actions.changeValue(address);
  };

  // Modo vista: mostrar como texto estático
  if (disabled) {
    return (
      <Box>
        <InputContainer title={t('global.location', 'Ubicación')}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
            {safeValue && <PlaceIcon sx={{ opacity: 0.5, color: (theme) => theme.palette.text.secondary }} fontSize="small" />}
            <Typography variant="body1" sx={{ color: (theme) => theme.palette.text.secondary, fontSize: '0.9rem' }}>
              {safeValue || '-'}
            </Typography>
          </Box>
        </InputContainer>
      </Box>
    );
  }

  return (
    <Box>
      <InputContainer title={t('global.location', 'Ubicación')}>
        <TextField
          {...restAttributes}
          value={safeValue}
          disabled={disabled}
          size="small"
          fullWidth
          variant="outlined"
          placeholder={t('global.addLocation', 'Agregar ubicación')}
          onClick={handleOpenModal}
          InputProps={{
            startAdornment: <PlaceIcon sx={{ mr: 1, opacity: 0.5 }} fontSize="small" />,
            readOnly: true,
          }}
          sx={{
            cursor: disabled ? 'default' : 'pointer',
            '& .MuiInputBase-input': {
              cursor: disabled ? 'default' : 'pointer',
            },
          }}
        />
      </InputContainer>

      <LocationSelectorModal
        open={showModal}
        onClose={handleCloseModal}
        onSelectLocation={handleLocationSelect}
        initialAddress={safeValue}
      />
    </Box>
  );
};

export default LocationTextField;
